<div class="progress-spinner" (click)="startAnimation()">
  <svg class="spinner" [attr.viewBox]="'0 0 ' + circleSize + ' ' + circleSize">
    <circle class="background"
            [attr.cx]="circleRadius"
            [attr.cy]="circleRadius"
            [attr.r]="circleRadius - strokeWidth / 2"
            fill="none"
            [attr.stroke-width]="strokeWidth"></circle>
    <circle #path class="path"
            [attr.cx]="circleRadius"
            [attr.cy]="circleRadius"
            [attr.r]="circleRadius - strokeWidth / 2"
            fill="none"
            [attr.stroke-width]="strokeWidth"></circle>
    <text [attr.x]="circleRadius"
          [attr.y]="circleRadius"
          text-anchor="middle"
          dominant-baseline="central"
          class="timer-text">{{remainingTime}}</text>
  </svg>
</div>

<div
  class="picker-container"
  (click)="unlockPicker($event)">
  <ion-picker
    [ngClass]="{ 'locked': isLocked }"
    (ionChange)="onDurationChange($event)"
    (touchstart)="onTouchStart()"
    (touchend)="onTouchEnd()"
  >
    <ion-picker-column [value]="animationDuration+''" name="duration">
      <ion-picker-column-option value="15">15s</ion-picker-column-option>
      <ion-picker-column-option value="30">30s</ion-picker-column-option>
      <ion-picker-column-option value="45">45s</ion-picker-column-option>
      <ion-picker-column-option value="60">1m</ion-picker-column-option>
      <ion-picker-column-option value="90">1m 30s</ion-picker-column-option>
      <ion-picker-column-option value="120">2m</ion-picker-column-option>
      <ion-picker-column-option value="150">2m 30s</ion-picker-column-option>
      <ion-picker-column-option value="180">3m</ion-picker-column-option>
      <ion-picker-column-option value="240">4m</ion-picker-column-option>
      <ion-picker-column-option value="300">5m</ion-picker-column-option>
    </ion-picker-column>
  </ion-picker>
  <div class="lock-icon" *ngIf="isLocked">
    <ion-icon name="lock-closed"></ion-icon>
  </div>
</div>
